export const PUBLIC = '/PublicMainPage'
export const LOGIN = '/login'
export const PRIVATE = '/PrivateMainPage'
export const LOGOUT = '/PrivateMainPage/logout'


